// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/tos/tos.css
// module id = 2044
// module chunks = 0